import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchBankBranch,
  fetchItem, 
} from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";


const { TextArea } = Input;

const AddCasualTypeModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { itemb, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.casHourlyRate) {
      toast.error("Please add hourly rate");
      return;
    }
    if (!formData?.casOvertimeHourlyRate) {
      toast.error("Please add overtime hour rate");
      return;
    }
    
    const res = await dispatch(
      save({
        casId: prodd?.casId ? prodd?.casId : null,
        casType: formData?.casType,
        casHourlyRate: formData?.casHourlyRate,
        casOvertimeHourlyRate:formData?.casOvertimeHourlyRate,      
        url: "hr/saveCasualType.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }
  async function fetchItemData(page, size) {
    dispatch(fetchItem());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.jbnkShtDesc}` : "Add casual type details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
         <Form.Item
            label="Casual Type"
            rules={[
              {
                required: true,
                message: "Enter Casual Type",
              },
            ]}
          >
            <Input
              required
              name="casType"
              onChange={onChange}
              value={formData?.casType}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Hourly Rate"
            rules={[
              {
                required: true,
                message: "Enter Hourly Rate",
              },
            ]}
          >
            <InputNumber
              name="casHourlyRate"
              value={formData?.casHourlyRate}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "casHourlyRate")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Overtime Hourly Rate"
            rules={[
              {
                required: true,
                message: "Enter Overtime Hourly Rate",
              },
            ]}
          >
            <InputNumber
              name="casOvertimeHourlyRate"
              value={formData?.casOvertimeHourlyRate}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "casOvertimeHourlyRate")}
              className="input flex"
            />
          </Form.Item>

           

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddCasualTypeModal;
